import { Theme } from '@mui/material/styles';
import { fontWeight } from '@mui/system';

// ----------------------------------------------------------------------

export default function Link(theme: Theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          color: theme.palette.mode === 'dark' ? theme.palette.primary.lighter : theme.palette.primary.main,
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
  };
}
